import { useDispatch } from 'react-redux';

import {
    openModal,
    ModalVariants
} from '../../../app/';
import { useSelectorTryNewCourseModuleIds } from '../../../configuration/configuration.selectors';
import { useSessionStorage } from '../../../storage/use-session-storage/use-session-storage';
import {
    useSelectorIsTeacherUser,
    useSelectorUserProfiles
} from '../../../user-profiles';

export const usePopupInterceptor = () => {
    const dispatch = useDispatch();
    const {
        getItem, setItem
    } = useSessionStorage();
    const isTeacher = useSelectorIsTeacherUser();
    const { data: userProfilesData } = useSelectorUserProfiles();
    const tryNewCourseModuleIds = useSelectorTryNewCourseModuleIds() || [];
    const showTryCourseModal = (moduleId: number) => {
        const userProfileId = userProfilesData?.user?.userProfileId;

        if (userProfileId) {
            const hasSeenTryRefreshedAssignReviewModalUserIds = getItem({
                moduleId,
                key: 'hasSeenTryRefreshedAssignReviewModal'
            }) || [];

            if (hasSeenTryRefreshedAssignReviewModalUserIds.includes(userProfileId)) return;
            const updatedUserProfileIds = [...hasSeenTryRefreshedAssignReviewModalUserIds, userProfileId];
            const showTryCoursePopover = tryNewCourseModuleIds.includes(moduleId);

            setItem({
                moduleId,
                key: 'hasSeenTryRefreshedAssignReviewModal',
                value: updatedUserProfileIds
            });

            if (isTeacher && showTryCoursePopover) {
                dispatch(openModal({ variant: ModalVariants.tryRefreshedAssignAndReviewModal }));
            }
        }

        return null;
    };

    return { showTryCourseModal };
};
